import { Col, Container, Form, Row, Button, Card, Spinner, FormGroup } from "react-bootstrap";
import Logo from "../components/Logo";
import CardHeader from "react-bootstrap/esm/CardHeader";
import { useEffect, useRef, useState } from 'react';
import { PaystackButton } from "react-paystack";
import Swal from "sweetalert2";
import { useSearchParams } from "react-router-dom";
import formatCurrency from "../utils/currencyFormmter";
import HmoPerk from "../components/hmo";
import axios from "axios";

const Payments = () => {

    const isLoaded = useRef(false)

    const initialState = {
        method: 'card',
        loading: false,
        show_rating_form: false,
        payload: {},
        invoice: {},
        errors: {},
        fee: 0.00,
        fees: [],
        keys: {public: "", private: ""}
        // amount: state.invoice?.amount || 0
    }
    
    const [method, setMethod] = useState('card')
    const [loading, setLoading] = useState(false)
    const [payload, setPayload] = useState({})
    const [searchParams, setSearchParams] = useSearchParams()
    const [invoice, setInvoice] = useState({})
    const [errors, setErrors] = useState({})
    const [fee, setFee]  = useState(0.00)
    const [fees, setFees] = useState([])
    const [amount, setAmount] = useState(0)

    const [state, setState] = useState(initialState)
    const [paystackKey, setPaystackKey] = useState('')
    
    // const dispatch = useDispatch();
    
    const componentProps = {
        email: payload?.email,
        amount: (amount * 100),
        metadata: {
          phone: payload?.phone_number, 
        },
        publicKey: paystackKey,
        text: `Pay ${formatCurrency(amount).with_currency}`,
        onSuccess: (data) => {
            verifyPayment(data.trxref)
        },
    }
    
    useEffect(() => {
        if(!isLoaded.current) {
            if(searchParams.get('ref')) {
                getInvoiceData(searchParams.get('ref'))
            }
            getThirdPartyKeys()
            isLoaded.current = true
        }
    }, []) 


    const handleSelection = (event) => {
        const { name, value } = event.target
        if(value === "card") {
            const invoiceTotal = parseFloat(invoice.amount) + parseFloat(fee)
            setAmount(invoiceTotal)
        } else {
            setAmount(invoice.amount)
        }
        setMethod(value)
    }

    const handleInput = (event) => {
        const {name, value} = event.target
        if(name === 'amount') {
            const newValue = parseFloat(value.replace(/[^\d.]/g, ''))
            setPayload((prevState)=> ({...prevState,[name]:newValue}))
        }
        else {
            setPayload((prevState) => ({...prevState, [name]: value}))
        }
    }

    const handleValidation = (event) => {

        const regex = /^\d*\.?\d*$/;
        const pattern = /[a-zA-Z0-9]+[\.]?([a-zA-Z0-9]+)?[\@][a-z]{3,9}[\.][a-z]{2,5}/g;
    
        const {name, value} = event.target
        if(value === '' && event.target.attributes.required) {
            event.target.style = "border: 1px solid red"
            setErrors((prevState) => ({ ...prevState, [name]: `${name[0].toUpperCase() + name.split('_').join(' ').slice(1)} is required` }))
        }
        else if(name === 'email' && !pattern.test(value)) {
            setErrors((prevState) => ({ ...prevState, [name]: 'Please enter a valid email address'}))
        }
        else if (name ==='amount' && !regex.test(parseFloat(value.replace(/[^\d.]/g, '')))) {
            event.target.style = "border: 1px solid red"
            setErrors((prevState) => ({ ...prevState, [name]: `${name[0].toUpperCase() + name.split('_').join(' ').slice(1)} is required` }))
        }
        else {
            event.target.style = "border-style: transparent"
            delete errors[name]
            setErrors(errors)
        }
    }
    

    const payWithPaycode = () => {
        if (!payload.token && !invoice.amount && !payload.secret) return;
        setLoading(true)

        let request_payload = payload
        request_payload.amount = invoice.amount
        request_payload.pay_mode = 'paycode'
        request_payload.invoice_id = invoice?.ref

        // dispatch(payInvoice(request_payload))
        axios.post(`${process.env.NODE_ENV === 'production' ? process.env.REACT_APP_BASE_URL_PROD : process.env.REACT_APP_BASE_URL_DEV}/api-v1/pay_invoice/${invoice.id}`, request_payload)
        .then((res) => {
            if(res.payload?.success === true) {
                Swal.fire({
                    icon: 'success',
                    text: res.payload?.message
                })
                .then(() => {
                    setState((prevState)=> ({...prevState, 'show_rating_form': true}))
                })
            }
            else if(res.payload?.success === 'False') {
                Swal.fire({
                    icon: 'error',
                    text: res.payload?.message
                })
            }
        })
        .finally(() => setLoading(false))
    }

    const getInvoiceData = (reference) => {
        setLoading(true)
        axios.get(`${process.env.NODE_ENV === 'production' ? process.env.REACT_APP_BASE_URL_PROD : process.env.REACT_APP_BASE_URL_DEV}/merchant_invoice/?ref=${reference}`)
        .then((response) => {
            if(response.data.results) {
                const invoice = response.data.results.filter(inv => inv.ref === reference)[0]
                // calculateFee(parseFloat(invoice.amount))
                setInvoice(invoice)
                setAmount(parseFloat(invoice.amount))
                getFees(parseFloat(invoice.amount))
            }
        })
        .catch((error) => { 
            Swal.fire({
                icon: 'error',
                text: error.response?.data?.message
            })
        })
        .finally(() => setLoading(false))
    }

    const getFees = (invoiceAmount) => {
        axios.get(`${process.env.NODE_ENV === 'production' ? process.env.REACT_APP_BASE_URL_PROD : process.env.REACT_APP_BASE_URL_DEV}/transaction_charges/`)
        .then((res) => {
            if(res.data?.length) {
                setFees(res.data)
                const charge = res.data.filter(fee => fee.name === 'paystack')[0].value
                let percentage = (charge / 100) * invoiceAmount

                // cap fee at 3000
                percentage = parseFloat(percentage) > 3000 ? 3000 : parseFloat(percentage)

                let totalAmount = invoiceAmount
                if(method === 'card') {
                    totalAmount = invoiceAmount + percentage
                }
                setAmount(totalAmount)
                setFee(percentage)
            }
        })
        .catch((err) => {
            console.log(err.response.data.message)
        })
    }

    const verifyPayment = (ref) => {
        // dispatch(payInvoice({payment_reference: ref, invoice_id: invoice?.ref, pay_mode: 'paystack'}))
        axios.post(`${process.env.NODE_ENV === 'production' ? process.env.REACT_APP_BASE_URL_PROD : process.env.REACT_APP_BASE_URL_DEV}/pay_invoice/${invoice?.ref}/`, {
            pay_mode: "paystack",
            payment_reference: ref
        })
        .then((res) => {
            if(res.payload?.success === true || res.payload?.success === 'True') {
                Swal.fire({
                    icon: 'success',
                    text: res.payload?.message
                })
                .then(() => {
                    setState((prevState)=> ({...prevState, 'show_rating_form': true}))
                })
            }
            else {
                Swal.fire({
                    icon: 'error',
                    text: res.payload?.message
                })
            }
        })
        .catch((err) => {
            Swal.fire({
                icon: "error",
                text: err.response.data.message
            })
        })
    }

    const calculateFee = (amount) => {
        let charge = 0
        let percentage = 0
        if(fees.length) {
            charge = fees.filter(fee => fee.name === 'paystack')[0].value
            percentage = (charge / 100) * amount
            setFee(percentage)
        }
        setAmount(amount + percentage)
    }

    const getThirdPartyKeys = () => {
        const credentials = `${process.env.REACT_APP_CLIENT_USER}:${process.env.REACT_APP_CLIENT_KEY}`
        const base64Credentials = btoa(credentials)
        axios.get(`${process.env.NODE_ENV === 'production' ? process.env.REACT_APP_BASE_URL_PROD : process.env.REACT_APP_BASE_URL_DEV}/api-v1/third_party_keys/`, {
            headers: {
                Authorization: `Basic ${base64Credentials}`
            }
        })
        .then(response => {
            if(response.data.data !== 'undefined') {
                const data = response.data.data
                if(data.pay_stack_live_key) {
                    setPaystackKey(data.pay_stack_public_key)
                }
            }
        }) 
        .catch(err => {
            // console.log(err)
        })
    }
    
    return (
        <Row className="full-height justify-content-center">
            <Col md={10} lg={7} sm={12} className="px-5">
                <Container className="mt-5 text-center px-5">
                    <div className="mt-3 mb-5">
                        <Logo variant="dark"/>
                    </div>
                </Container>
                <Container className="px-5 px-md-5 mt-5">
                    <Card className="border-0 shadow">
                        <CardHeader className="justify-content-between d-flex">
                            <h5>Payment Methods</h5>
                            <h5>{formatCurrency(amount).with_currency}</h5>
                        </CardHeader>
                        <Card.Body>
                            <p>Please select a payment option to complete your payment</p>
                            <Row>
                                <Col md={3}>
                                    <Form.Check
                                        type="radio"
                                        className="text-primary font-bold"
                                        label="Card"
                                        name="payment_method"
                                        onChange={handleSelection}
                                        value="card"
                                        checked={ method === "card" }
                                    />
                                    <Form.Check
                                        type="radio"
                                        className="text-primary font-bold"
                                        label="Bank"
                                        name="payment_method"
                                        onChange={handleSelection}
                                        value="bank"
                                    />
                                    <Form.Check
                                        type="radio"
                                        className="text-primary font-bold"
                                        label="PayCode"
                                        name="payment_method"
                                        onChange={handleSelection}
                                        value="paycode"
                                    />
                                </Col>
                                <Col md={9}>
                                    {
                                        method === 'card' ? (
                                            <>
                                                <h5>Credit/Debit Card</h5>
                                                <hr/>
                                                <Form>
                                                    <Row>
                                                        <Form.Group as={Col} md={12} className="mb-2">
                                                            <Form.Text>Email</Form.Text>
                                                            <Form.Control
                                                                type="email"
                                                                placeholder="Email"
                                                                required
                                                                name="email"
                                                                onChange={handleInput}
                                                                onKeyUp={handleValidation}
                                                            />
                                                            {
                                                                errors['email'] && 
                                                                <Form.Text className="text-danger">{errors['email']}</Form.Text>
                                                            }
                                                        </Form.Group>
                                                        <Form.Group as={Col} md={12} className="mb-2">
                                                            <Form.Text>Phone Number</Form.Text>
                                                            <Form.Control
                                                                type="tel"
                                                                placeholder="Phone Number"
                                                                required
                                                                name="phone_number"
                                                                maxLength={11}
                                                                minLength={11}
                                                                onChange={handleInput}
                                                                onKeyUp={handleValidation}
                                                            />
                                                            {
                                                                errors['phone_number'] && 
                                                                <Form.Text className="text-danger">{errors['phone_number']}</Form.Text>
                                                            }
                                                        </Form.Group>
                                                    </Row>
                                                    <p className="text-primary font-bold">You will be charged {formatCurrency(fee).with_currency} as service fee. </p>
                                                </Form>
                                                <PaystackButton className="btn btn-primary" {...componentProps} />
                                                {/* <Button type="button" onClick={() => setState((prevState)=> ({...prevState, 'show_rating_form': true}))}>Rating</Button> */}
                                            </>
                                        )
                                        : 
                                        method === 'bank' ? (
                                            <>
                                                <h5>Transfer via Bank</h5>
                                                <hr/>
                                                <p>Pay into the business account:</p>
                                                {
                                                    invoice?.merchant_banks?.length ? (
                                                        invoice?.merchant_banks.map(bank => (
                                                            <div className="mb-3" key={bank.id}>
                                                                <p className="m-0">Account Number: <strong>{  bank.account_number }</strong></p>
                                                                <p className="m-0">Account Name: <strong>{ bank.account_name }</strong></p>
                                                                <p className="m-0">Bank Name: <strong>{ bank.bank_name }</strong></p>
                                                                <p className="m-0">Payment Reference: <strong>{ invoice?.ref }</strong></p>
                                                                <p className="text-primary font-bold text-sm mt-2">Please ensure to use the above payment reference in your payment narration.</p>
                                                                <hr />
                                                            </div>
                                                        ))
                                                    ) : null
                                                }
                                            </>
                                        )
                                        : 
                                        method === 'paycode' ? (
                                            <>
                                            <h5>PayCode Payment</h5>
                                            <hr/>
                                            <Row>
                                                <FormGroup as={Col} md={12} className="mb-2">
                                                    <Form.Label>Amount</Form.Label>
                                                    <Form.Control
                                                        required
                                                        placeholder="N0.00"
                                                        name="amount"
                                                        disabled
                                                        // onChange={handleInput}
                                                        // onKeyUp={handleValidation}
                                                        value={ parseFloat(invoice?.amount) > 0 ? formatCurrency(invoice?.amount).formatted : ''}
                                                    />
                                                    {
                                                        errors['amount'] && 
                                                        <Form.Text className="text-danger">{errors['amount']}</Form.Text>
                                                    }
                                                </FormGroup>
                                                <FormGroup as={Col} md={12} className="mb-2">
                                                    <Form.Label>PayCode</Form.Label>
                                                    <Form.Control
                                                        required
                                                        placeholder="paycode token"
                                                        name="token"
                                                        onChange={handleInput}
                                                        onKeyUp={handleValidation}
                                                        value={payload?.token || ''}
                                                        maxLength={6}
                                                        minLength={6}
                                                    />
                                                    {
                                                        errors['token'] && 
                                                        <Form.Text className="text-danger">{errors['token']}</Form.Text>
                                                    }
                                                </FormGroup>
                                                <FormGroup as={Col} md={12} className="mb-2">
                                                    <Form.Label>Secret</Form.Label>
                                                    <Form.Control
                                                        type="password"
                                                        required
                                                        placeholder="Secret"
                                                        name="secret"
                                                        onChange={handleInput}
                                                        // maxLength={6}
                                                        // minLength={4}
                                                        onKeyUp={handleValidation}
                                                    />
                                                    {
                                                        errors['secret'] && 
                                                        <Form.Text className="text-danger">{errors['secret']}</Form.Text>
                                                    }
                                                </FormGroup>
                                                <FormGroup as={Col} md={12} className="mb-2">
                                                    <Button
                                                        type="button" 
                                                        variant="primary" 
                                                        onClick={payWithPaycode}
                                                        disabled={Object.keys(errors).length > 0}
                                                    >
                                                        Pay now  <Spinner animation={ loading ? "border" : null} role="status" size="sm"></Spinner>
                                                    </Button>
                                                </FormGroup>
                                            </Row>
                                            </>
                                        )
                                        : null
                                    }
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>




                    {/* Customer rating */}
                    <HmoPerk
                        merchant={invoice.merchant_data ?? ''}
                        show_form={state.show_rating_form}
                        hide_form={ () => setState((prevState)=> ({...prevState, 'show_rating_form': false})) }
                    />
                </Container>
            </Col>
        </Row>
    ); 
}


export default Payments;